import React from "react";
import { Dispatch, SetStateAction } from "react";
import { Button, Typography, Dialog }  from "@material-tailwind/react";
import { FormProvider, useForm } from 'react-hook-form'

import FormInput from "../../../../components/FormInput";
import { name_validation, date_validation, year_validation } from "../../../../utils/inputValidations";
import { Part } from "../../../../redux/vehicles/actions";
import { RootState } from "../../../../redux";
import { useSelector } from "react-redux";


const DETALIS_FIELDS = [
    { n: "Name", f: "name", type: "text", editable: true },
    { n: "Part Number", f: "number", type: "text", editable: true },
    { n: "Quantity", f: "qty", type: "number", editable: true },
    { n: "Price", f: "cost", type: "money", editable: true },
];

interface DialogAddPartProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    onSubmit: (part: Part) => void;
}

export const DialogAddPart: React.FC<DialogAddPartProps> = ({
    isOpen,
    setIsOpen,
    onSubmit,
}) => {
    const { auth } = useSelector((state: RootState) => state.auth);
    const methods = useForm();

    const onFormSubmit = methods.handleSubmit(data => {
        onSubmit({...data, signed_by_id: auth?.user?.user?.id} as Part);
    });

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen} size="lg">
            <Dialog.Overlay>
                <Dialog.Content className="p-2 md:p-8">
                    <div className="flex flex-col gap-1 p-2 md:p-6 pb-4 border-b border-surface">
                        <Typography type="h5" color="default">
                            New Part
                        </Typography>
                    </div>
                    <FormProvider {...methods}>
                        <form
                            className="flex flex-col p-2 md:p-6"
                            onSubmit={(e) => e.preventDefault()}
                            noValidate
                            autoComplete="off"
                        >
                            <div className="grid grid-cols-2 gap-y-5 justify-stretch">
                                {DETALIS_FIELDS.map((field, idx) => (
                                    <div className="" key={idx}>
                                        {field.type === "date" ? (
                                            <FormInput
                                                {...date_validation}
                                                label={field.n}
                                                labelClass="mb-2 font-medium text-sm text-foreground"
                                                wrapperClass="mt-1 w-[95%]"
                                                name={field.f}
                                                type="text"
                                                placeholder=""
                                            />
                                        ) : field.type === "year" ? (
                                            <FormInput
                                                {...year_validation}
                                                label={field.n}
                                                labelClass="mb-2 font-medium text-sm text-foreground"
                                                wrapperClass="mt-1 w-[95%]"
                                                name={field.f}
                                                type="number"
                                                placeholder=""
                                            />
                                        ) : (
                                            <FormInput
                                                {...name_validation}
                                                label={field.n}
                                                labelClass="mb-2 font-medium text-sm text-foreground"
                                                wrapperClass="mt-1 w-[95%]"
                                                name={field.f}
                                                type={
                                                    field.type === "money" ? "number" : field.type
                                                }
                                                placeholder=""
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </form>
                    </FormProvider>
                    <div className="flex gap-3 justify-end p-6 border-t border-surface">
                        <Button
                            variant="outline"
                            color="secondary"
                            onClick={() => setIsOpen(false)}
                            className="mr-1"
                        >
                            Cancel
                        </Button>
                        <Button variant="solid" color="primary" onClick={onFormSubmit}>
                            Confirm
                        </Button>
                    </div>
                </Dialog.Content>
            </Dialog.Overlay>
        </Dialog>
    );
};